import React, { useEffect,useState } from 'react';
import { Helmet } from 'react-helmet';
import HeaderNavbar from './MainHeader';
import SidebarOryza from './SidebarOryza';
import Sidebar from './SideNavigation';
import Header from './Header';
import Footer from './Footer';

const GalleryPage = () => {

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth <= 768);
    checkScreen();
    window.addEventListener('resize', checkScreen);
    return () => window.removeEventListener('resize', checkScreen);
  }, []);

  const headingStyle = {
    fontFamily: "'Yellowtail', cursive",
    fontWeight: 400,
    fontSize: isMobile ? '40px' : '79px',
    lineHeight: isMobile ? '48px' : '95px',
    color: '#fff',
  };
    useEffect(() => {
        // Define updateProgress at a higher scope
        let updateProgress;

        // Function to load scripts in order
        const loadScript = (src) => {
            return new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.src = src;
                script.onload = resolve;
                script.onerror = reject;
                document.body.appendChild(script);
            });
        };

        // Load all required scripts and initialize
        const initializeGallery = async () => {
            try {
                // Load jQuery first if not already loaded
                if (!window.jQuery) {
                    await loadScript('https://code.jquery.com/jquery-3.6.0.min.js');
                }

                // Load Fancybox
                await loadScript('https://cdnjs.cloudflare.com/ajax/libs/fancybox/3.5.7/jquery.fancybox.min.js');

                // Load Isotope
                await loadScript('https://cdnjs.cloudflare.com/ajax/libs/jquery.isotope/3.0.6/isotope.pkgd.min.js');

                // Now initialize the plugins
                const $ = window.jQuery;

                // Initialize Fancybox
                $('[data-fancybox="gallery-1"]').fancybox({
                    animationEffect: "zoom-in-out",
                    animationDuration: 500,
                    transitionEffect: "fade",
                    transitionDuration: 300,
                    buttons: [
                        "zoom",
                        "share",
                        "slideShow",
                        "fullScreen",
                        "download",
                        "thumbs",
                        "close"
                    ],
                });

                // Initialize Isotope
                $('.sortable-masonry').each(function () {
                    const $this = $(this);
                    const filter = $this.find('.filter-tabs');
                    const container = $this.find('.items-container');

                    container.isotope({
                        filter: '*',
                        animationOptions: {
                            duration: 750,
                            easing: 'linear',
                            queue: false
                        }
                    });

                    filter.find('li').on('click', function () {
                        const selector = $(this).attr('data-filter');
                        filter.find('li').removeClass('active');
                        $(this).addClass('active');
                        container.isotope({
                            filter: selector,
                            animationOptions: {
                                duration: 750,
                                easing: 'linear',
                                queue: false
                            }
                        });
                        return false;
                    });
                });

                // Initialize back to top button
                const progressPath = document.querySelector('.progress-wrap path');
                if (progressPath) {
                    const pathLength = progressPath.getTotalLength();
                    progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
                    progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
                    progressPath.style.strokeDashoffset = pathLength;
                    progressPath.getBoundingClientRect();
                    progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';

                    // Define updateProgress function
                    updateProgress = () => {
                        const scroll = window.pageYOffset;
                        const height = document.documentElement.scrollHeight - window.innerHeight;
                        const progress = pathLength - (scroll * pathLength / height);
                        progressPath.style.strokeDashoffset = progress;
                    };

                    updateProgress();
                    window.addEventListener('scroll', updateProgress);

                    const offset = 50;
                    const progressWrap = document.querySelector('.progress-wrap');
                    window.addEventListener('scroll', function () {
                        if (window.pageYOffset > offset) {
                            progressWrap.classList.add('active-progress');
                        } else {
                            progressWrap.classList.remove('active-progress');
                        }
                    });

                    progressWrap.addEventListener('click', function (e) {
                        e.preventDefault();
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                        return false;
                    });
                }

                // Hide preloader
                const preloader = document.getElementById('preloader');
                if (preloader) {
                    setTimeout(() => {
                        preloader.style.display = 'none';
                    }, 500);
                }
            } catch (error) {
                console.error('Error loading scripts:', error);
            }
        };

        initializeGallery();

        // Cleanup
        return () => {
            if (updateProgress) {
                window.removeEventListener('scroll', updateProgress);
            }
        };
    }, []);

    return (
        <>
            <Header />
            <HeaderNavbar />
            <SidebarOryza />
            <Sidebar />

            <Helmet>
                <title>Gallery | Banana Bunks Kandy | Oryza Leisure</title>

                {/* Google Fonts */}
                <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Jost%3A100%2C200%2C300%2Cregular%2C500%2C600%2C700%2C800%2C900%2C100italic%2C200italic%2C300italic%2Citalic%2C500italic%2C600italic%2C700italic%2C800italic%2C900italic%7CAmiri%3Aregular%2Citalic%2C700%2C700italic%7CAllison%3Aregular&#038;subset=cyrillic%2Clatin%2Clatin-ext%2Carabic%2Cvietnamese&#038;ver=6.0.1" />
                <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Oswald%3A200%2C300%2Cregular%2C500%2C600%2C700%7CMerriweather%3A300%2C300italic%2Cregular%2Citalic%2C700%2C700italic%2C900%2C900italic%7CJost%3A100%2C200%2C300%2Cregular%2C500%2C600%2C700%2C800%2C900%2C100italic%2C200italic%2C300italic%2Citalic%2C500italic%2C600italic%2C700italic%2C800italic%2C900italic%7CMontserrat%3A100%2C100italic%2C200%2C200italic%2C300%2C300italic%2Cregular%2Citalic%2C500%2C500italic%2C600%2C600italic%2C700%2C700italic%2C800%2C800italic%2C900%2C900italic%7CAllison%3Aregular&#038;subset=cyrillic%2Ccyrillic-ext%2Clatin%2Clatin-ext%2Cvietnamese&#038;ver=6.0.1" />
                <link href="https://fonts.googleapis.com/css2?family=Yellowtail&display=swap" rel="stylesheet" />
                <link href="https://fonts.googleapis.com/css2?family=Handlee&family=Neucha&family=Pacifico&family=Patrick+Hand&family=Patrick+Hand+SC&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Sacramento&display=swap" rel="stylesheet" />

                {/* Fancybox CSS */}
                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/fancybox/3.5.7/jquery.fancybox.min.css" />

                {/* Base CSS */}
                <link href="/bbkandy/css/style.css" rel="stylesheet" />
                <link href="/pettipetti/css/secondary/style.css" rel="stylesheet" />
                <link href="/pettipetti/css/vendors.min.css" rel="stylesheet" />

                {/* Custom CSS */}
                <link href="/pettipetti/css/custom.css" rel="stylesheet" />
                <link rel="stylesheet" href="/bbkandy/css/gallery/bootstrap.css" />
                <link rel="stylesheet" href="/bbkandy/css/gallery/style.css" />
            </Helmet>

            <div id="preloader">
                <div data-loader="circle-side"></div>
            </div>

            <div
        className="hotale-page-title-wrap hotale-style-custom hotale-center-align"
        style={{ backgroundImage: 'url(/bbkandy/images/rooms/header.webp)' }}
      >
        <div className="hotale-header-transparent-substitute" style={{ height: '135px' }}></div>
        <div className="hotale-page-title-overlay"></div>
        <div className="hotale-page-title-container hotale-container">
          <div className="hotale-page-title-content hotale-item-pdlr">
            <h1
              className="gdlr-core-title-item-title gdlr-core-skin-title class-test hotale-additional-font slidertitle"
              style={headingStyle}
            >
              Gallery
            </h1>
          </div>
        </div>
      </div>

            <section className="gallery-section-two bbkandybg_m">
                <div className="auto-container">
                    {/* Masonry Gallery */}
                    <div className="sortable-masonry filter-gallery">
                        <div className="filters clearfix">
                            <ul className="filter-tabs filter-btns clearfix">
                                <li className="filter active" data-role="button" data-filter=".all">All</li>
                                <li className="filter" data-role="button" data-filter=".lounge">Lounge</li>
                                <li className="filter" data-role="button" data-filter=".bunks">Bunks</li>
                                <li className="filter" data-role="button" data-filter=".rooms">Rooms</li>
                                <li className="filter" data-role="button" data-filter=".food">Food</li>
                                <li className="filter" data-role="button" data-filter=".pool">Pool</li>
                            </ul>
                        </div>

                        <div className="items-container row clearfix">
                            {/* Gallery items */}
                            {/* Lounge */}
                            <div className="gallery-item masonry-item all lounge col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/lounge/1.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/lounge/1.jpg" className="overlink lightbox-image" data-fancybox="gallery-1" aria-label="View image"></a>
                                    </div>
                                </div>
                            </div>

                            {/* Bunks */}
                            <div className="gallery-item masonry-item all bunks col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/bunks/2.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/bunks/2.jpg" className="overlink lightbox-image" data-fancybox="gallery-1" aria-label="View image"></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all bunks col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/bunks/3.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/bunks/3.jpg" className="overlink lightbox-image" data-fancybox="gallery-1"><span className="icon flaticon-cross"></span></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all bunks col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/bunks/1.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/bunks/1.jpg" className="overlink lightbox-image" data-fancybox="gallery-1"><span className="icon flaticon-cross"></span></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all bunks col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/bunks/4.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/bunks/4.jpg" className="overlink lightbox-image" data-fancybox="gallery-1"><span className="icon flaticon-cross"></span></a>
                                    </div>
                                </div>
                            </div>

                            {/* Rooms */}
                            <div className="gallery-item masonry-item all rooms col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/rooms/1.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/rooms/1.jpg" className="overlink lightbox-image" data-fancybox="gallery-1"><span className="icon flaticon-cross"></span></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all bunks col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/bunks/5.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/bunks/5.jpg" className="overlink lightbox-image" data-fancybox="gallery-1"><span className="icon flaticon-cross"></span></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all rooms col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/rooms/2.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/rooms/2.jpg" className="overlink lightbox-image" data-fancybox="gallery-1" aria-label="View image"></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all rooms col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/rooms/3.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/rooms/3.jpg" className="overlink lightbox-image" data-fancybox="gallery-1"><span className="icon flaticon-cross"></span></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all rooms col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/rooms/4.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/rooms/4.jpg" className="overlink lightbox-image" data-fancybox="gallery-1"><span className="icon flaticon-cross"></span></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all rooms col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/rooms/5.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/rooms/5.jpg" className="overlink lightbox-image" data-fancybox="gallery-1"><span className="icon flaticon-cross"></span></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all rooms col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/rooms/6.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/rooms/6.jpg" className="overlink lightbox-image" data-fancybox="gallery-1"><span className="icon flaticon-cross"></span></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all rooms col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/rooms/7.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/rooms/7.jpg" className="overlink lightbox-image" data-fancybox="gallery-1"><span className="icon flaticon-cross"></span></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all rooms col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/rooms/8.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/rooms/8.jpg" className="overlink lightbox-image" data-fancybox="gallery-1"><span className="icon flaticon-cross"></span></a>
                                    </div>
                                </div>
                            </div>

                            {/* Food */}
                            <div className="gallery-item masonry-item all food col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/food/1.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/food/1.jpg" className="overlink lightbox-image" data-fancybox="gallery-1" aria-label="View image"></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all food col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/food/2.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/food/2.jpg" className="overlink lightbox-image" data-fancybox="gallery-1"><span className="icon flaticon-cross"></span></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all food col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/food/3.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/food/3.jpg" className="overlink lightbox-image" data-fancybox="gallery-1"><span className="icon flaticon-cross"></span></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all food col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/food/4.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/food/4.jpg" className="overlink lightbox-image" data-fancybox="gallery-1"><span className="icon flaticon-cross"></span></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all food col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/food/5.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/food/5.jpg" className="overlink lightbox-image" data-fancybox="gallery-1"><span className="icon flaticon-cross"></span></a>
                                    </div>
                                </div>
                            </div>

                            {/* Pool */}
                            <div className="gallery-item masonry-item all pool col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/pool/1.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/pool/1.jpg" className="overlink lightbox-image" data-fancybox="gallery-1" aria-label="View image"></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all pool col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/pool/2.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/pool/2.jpg" className="overlink lightbox-image" data-fancybox="gallery-1"><span className="icon flaticon-cross"></span></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all pool col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/pool/3.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/pool/3.jpg" className="overlink lightbox-image" data-fancybox="gallery-1"><span className="icon flaticon-cross"></span></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all pool col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/pool/4.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/pool/4.jpg" className="overlink lightbox-image" data-fancybox="gallery-1"><span className="icon flaticon-cross"></span></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all pool col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/pool/5.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/pool/5.jpg" className="overlink lightbox-image" data-fancybox="gallery-1"><span className="icon flaticon-cross"></span></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all pool col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/pool/6.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/pool/6.jpg" className="overlink lightbox-image" data-fancybox="gallery-1"><span className="icon flaticon-cross"></span></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all lounge col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/lounge/2.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/lounge/2.jpg" className="overlink lightbox-image" data-fancybox="gallery-1"><span className="icon flaticon-cross"></span></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all lounge col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/lounge/3.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/lounge/3.jpg" className="overlink lightbox-image" data-fancybox="gallery-1"><span className="icon flaticon-cross"></span></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all lounge col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/lounge/4.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/lounge/4.jpg" className="overlink lightbox-image" data-fancybox="gallery-1"><span className="icon flaticon-cross"></span></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all lounge col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/lounge/5.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/lounge/5.jpg" className="overlink lightbox-image" data-fancybox="gallery-1"><span className="icon flaticon-cross"></span></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all lounge col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/lounge/6.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/lounge/6.jpg" className="overlink lightbox-image" data-fancybox="gallery-1"><span className="icon flaticon-cross"></span></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all lounge col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/lounge/7.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/lounge/7.jpg" className="overlink lightbox-image" data-fancybox="gallery-1"><span className="icon flaticon-cross"></span></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all lounge col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/lounge/8.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/lounge/8.jpg" className="overlink lightbox-image" data-fancybox="gallery-1"><span className="icon flaticon-cross"></span></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all lounge col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/lounge/9.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/lounge/9.jpg" className="overlink lightbox-image" data-fancybox="gallery-1" aria-label="View image"></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all lounge col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/lounge/10.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/lounge/10.jpg" className="overlink lightbox-image" data-fancybox="gallery-1"><span className="icon flaticon-cross"></span></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all lounge col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/lounge/11.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/lounge/11.jpg" className="overlink lightbox-image" data-fancybox="gallery-1"><span className="icon flaticon-cross"></span></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all lounge col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/lounge/12.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/lounge/12.jpg" className="overlink lightbox-image" data-fancybox="gallery-1"><span className="icon flaticon-cross"></span></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all lounge col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/lounge/13.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/lounge/13.jpg" className="overlink lightbox-image" data-fancybox="gallery-1"><span className="icon flaticon-cross"></span></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all lounge col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/lounge/14.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/lounge/14.jpg" className="overlink lightbox-image" data-fancybox="gallery-1"><span className="icon flaticon-cross"></span></a>
                                    </div>
                                </div>
                            </div>

                            <div className="gallery-item masonry-item all lounge col-lg-4 col-md-6 col-sm-12">
                                <div className="gallery-block">
                                    <div className="inner-box">
                                        <div className="imageg">
                                            <img src="/bbkandy/images/gallery/thumbnail/lounge/15.jpg" alt="" title="" />
                                        </div>
                                        <a href="/bbkandy/images/gallery/lounge/15.jpg" className="overlink lightbox-image" data-fancybox="gallery-1"><span className="icon flaticon-cross"></span></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />

            <div className="progress-wrap">
                <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
                    <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
                </svg>
            </div>

            {/* Scripts */}
            <script src="/bbkandy/jss/common_scripts.js"></script>
            <script src="/bbkandy/jss/common_functions.js"></script>
            <script src="/bbkandy/jss/slider.js"></script>
        </>
    );
};

export default GalleryPage;
